import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QrCodeComponent } from './qr-code.component';

@NgModule({
    imports: [
        CommonModule
    ],
    exports: [
        QrCodeComponent
    ],
    declarations: [
        QrCodeComponent
    ]
})
export class QrCodeModule {
}
